import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useCallback, useImperativeHandle, useEffect } from "react";
import PropTypes from "prop-types";
import { defer } from "lodash/fp";
import { CalendarWrapper } from "./calendar.styles.es.js";
import { useOnClickOutside } from "../../hooks/use-on-click-outside.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  inputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  onCancel: PropTypes.func.isRequired
};
const defaultProps = {
  inputRef: void 0
};
const Calendar = forwardRef(
  ({ children, inputRef, onCancel, ...restProps }, forwardedRef) => {
    const ref = useRef();
    const handleBlur = useCallback(
      ({ currentTarget, relatedTarget }) => {
        if (!currentTarget.contains(relatedTarget)) {
          onCancel();
        }
      },
      [onCancel]
    );
    useOnClickOutside(
      [ref, inputRef],
      useCallback(() => {
        if (onCancel) {
          onCancel();
        }
      }, [onCancel])
    );
    useImperativeHandle(forwardedRef, () => ref.current);
    useEffect(() => {
      defer(() => {
        if (ref.current) {
          ref.current.focus();
        }
      });
    }, []);
    return /* @__PURE__ */ jsx(
      CalendarWrapper,
      {
        ref,
        role: "dialog",
        onBlur: handleBlur,
        tabIndex: -1,
        ...restProps,
        children
      }
    );
  }
);
Calendar.propTypes = propTypes;
Calendar.defaultProps = defaultProps;
export {
  Calendar
};
